// src/frontend/src/components/Layout/Layout.tsx - Enhanced with upgrade touchpoints
import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import PersistentUpgradeSidebar from '../Common/PersistentUpgradeSidebar';
import MobileUpgradeFloatingButton from '../Common/MobileUpgradeFloatingButton';

interface LayoutProps {
  children: React.ReactNode;
  showUpgradeTouchpoints?: boolean; // Option to disable on certain pages
}

const Layout: React.FC<LayoutProps> = ({ children, showUpgradeTouchpoints = true }) => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-100 relative">
      <Navbar />
      <main className="flex-grow max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8 w-full">
        {children}
      </main>
      <Footer />
      
      {/* Persistent Upgrade Touchpoints */}
      {showUpgradeTouchpoints && (
        <>
          {/* Desktop Sidebar Widget - Right side, always visible */}
          <PersistentUpgradeSidebar />
          
          {/* Mobile Floating Action Button */}
          <MobileUpgradeFloatingButton />
        </>
      )}
    </div>
  );
};

export default Layout;